<template>
  <v-app>
    <v-main>
      <DialogComponent ref="dialogComponent"></DialogComponent>
      <NotificationDialog ref="notificationDialog"></NotificationDialog>
      <PrivacyWarningDialog ref="privacyWarningDialog"></PrivacyWarningDialog>

      <CRMLocalityDialog ref="CRMLocalityDialog"></CRMLocalityDialog>
      <CRMWhatsappContactDialog ref="CRMWhatsappContactDialog"></CRMWhatsappContactDialog>
      <CRMWhatsappContactNoteDialog ref="CRMWhatsappContactNoteDialog"></CRMWhatsappContactNoteDialog>
      
      <CRMWhatsappContactCardDialog ref="CRMWhatsappContactCardDialog"></CRMWhatsappContactCardDialog>
      
      <CRMWhatsappMessageNoteDialog ref="CRMWhatsappMessageNoteDialog"></CRMWhatsappMessageNoteDialog>
      <router-view/>
    </v-main>
  </v-app>
</template>

<style>

  .hoverableVIcon {
    transition: transform 0.2s ease;
    cursor: pointer;
  }
  .hoverableVIcon:hover {
    transform: scale(1.05);
    cursor: pointer;
  }

  .hoverableVListItem {
    transition: transform 0.2s ease;
    cursor: pointer;
  }
  .hoverableVListItem:hover {
    transform: scale(1.01);
    cursor: pointer;
  }

  .hoverableVButton {
    transition: transform 0.2s ease;
    cursor: pointer;
  }
  .hoverableVButton:hover {
    transform: scale(1.01);
    cursor: pointer;
  }

  .hoverableImage {
    transition: transform 0.2s ease;
    cursor: pointer;
  }
  .hoverableImage:hover {
    transform: scale(1.05);
    cursor: pointer;
  }

  .successVDataTableRow {
    background-color: rgba(67, 160, 71, 0.25);
  }




  .bluredVDataTableRow {
    opacity: 0.5;
    cursor: default;
    user-select: none;
  }

  .loadingVDataTableRow {
      opacity: 1;
      pointer-events: none;
      cursor: default;
      user-select: none;
      animation: loadingVDataTableRowPulse 1.5s ease-in-out infinite;
      background: linear-gradient(90deg, 
        rgba(0,0,0,0) 0%, 
        rgba(0,0,0,0.1) 25%, 
        rgba(0,0,0,0.2) 50%, 
        rgba(0,0,0,0.1) 75%, 
        rgba(0,0,0,0) 100%
      );
      background-size: 200% 100%;
      animation: loadingVDataTableRowPulse 1.5s ease-in-out infinite, loadingVDataTableRowShimmer 1.5s linear infinite;
      position: relative;
    }

  .loadingVDataTableRow::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.05);
    pointer-events: none;
  }
  
  @keyframes loadingVDataTableRowPulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes loadingVDataTableRowShimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }


  .appearingVDataTableRow {
    animation: appearingVDataTableRow 1s ease-in-out;
  }
  @keyframes appearingVDataTableRow {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }


  .selectedVDataTableRow {
    background-color: rgba(0, 0, 0, 0.15);
  }

  .selectedCircularVChip {
    opacity: 0.5;
    border: 3px dotted #000;
  }

  .selectedVListItemClear {
    background-color: rgba(255, 255, 255, 0.1);
  }

  .selectedVListItem {
    background-color: rgba(0, 0, 0, 0.25);
  }

  .hoverableElement {
    transition: transform 0.2s ease;
    cursor: pointer;
  }
  .hoverableElement:hover {
    transform: scale(1.1);
    cursor: pointer;
  }

  .hoverableText {
    transition: transform 0.2s ease;
    cursor: pointer;
  }
  .hoverableText:hover {
    transform: scale(1.01);
  }

  .pulseElement {
    cursor: pointer;
    animation: pulse 1.5s infinite;
  }

  @keyframes pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.2); }
    100% { transform: scale(1); }
  }

  .pulseSmallElement {
    cursor: pointer;
    animation: pulseSmall 1.5s infinite;
  }

  @keyframes pulseSmall {
    0% { transform: scale(1); }
    50% { transform: scale(1.1); }
    100% { transform: scale(1); }
  }
</style>

<script>
  import DialogComponent from './components/DialogComponent.vue';
  import NotificationDialog from './components/NotificationDialog.vue';

  import PrivacyWarningDialog from './components/PrivacyWarningDialog.vue';
  import CRMLocalityDialog from './components/CRMLocalityDialog.vue';
  import CRMWhatsappContactNoteDialog from './components/CRMWhatsappContactNoteDialog.vue';
  
  import CRMWhatsappContactCardDialog from './components/CRMWhatsappContactCardDialog.vue';

  import CRMWhatsappMessageNoteDialog from './components/CRMWhatsappMessageNoteDialog.vue';
  export default {
    name: 'App',

    components:
    {
      DialogComponent,
      NotificationDialog,
      PrivacyWarningDialog,
      CRMLocalityDialog,
      CRMWhatsappContactNoteDialog,
      CRMWhatsappContactCardDialog,

      CRMWhatsappMessageNoteDialog
    },

    data: () => ({}),

    mounted(){
      document.title = 'SOUQ - CRM';
      this.$root.dialogComponent = this.$refs.dialogComponent;
      this.$root.notificationDialog = this.$refs.notificationDialog;
      this.$root.privacyWarningDialog = this.$refs.privacyWarningDialog;
      this.$root.CRMLocalityDialog = this.$refs.CRMLocalityDialog;
      this.$root.CRMWhatsappContactNoteDialog = this.$refs.CRMWhatsappContactNoteDialog;
      this.$root.CRMWhatsappContactCardDialog = this.$refs.CRMWhatsappContactCardDialog;
      this.$root.CRMWhatsappMessageNoteDialog = this.$refs.CRMWhatsappMessageNoteDialog;
    }
  }
</script>
